import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      return localStorage.getItem("cvg_user") || null;
    } catch (error) {
      console.log("error while parsing data");
      return null;
    }
  });

  const login = (user) => {
    localStorage.setItem("cvg_user", user);
    sessionStorage.removeItem("cvg_user"); // cleanup old temp sessions
    setUser(user);
  };

  const logout = () => {
    localStorage.removeItem("cvg_user");
    sessionStorage.removeItem("cvg_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
